import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef} from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
// -
import {SwalAlertClass} from "core/swalClass";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";

import axiApi from "ApiCaller";
import Form from "react-bootstrap/Form";
import ManagerSensorsForm from "./models/form/ManagerSensorsForm";
import {useNavigate} from "react-router-dom";
import FormButton from "components/buttons/FormButton";

const FormSensors = ({show, setShow, item, models, items, setItemsShown}) => {
    const {t} = useTranslation("forms");
    const {t: tC} = useCustomTranslation(translations);
    const navigate = useNavigate();
    const Alert = new SwalAlertClass({confirmButtonText: tC("button.accept")});
    const formRef = useRef();
    const [formData, setFormData] = useState({...item});
    const [model, setModel] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setFormData({...item});
        if (item.id) {
            setModel(item.model);
        }
    }, [item]);

    const handleClose = () => setShow(false);

    const onChange = (e) => {
        setModel(e.target.value);
    };
    const handleSubmit = () => {
        let form = new FormData(formRef.current);
        let data = {};
        for (let [key, value] of form.entries()) {
            data[key] = value;
        }

        if (!data.name || !data.model) {
            Alert.error("Error", t("message.error.required"));
            return;
        }

        setIsLoading(true);
        axiApi.post(`/api/devices/configs/sensors/save/`, data).then((resp) => {
            Alert.success(tC("message.success.title"), tC("message.success.text"))
                .then(() => {
                    navigate(0);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        });
    };

    return (
        <>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="end"
                backdrop="static"
                style={{width: "80%", fontSize: "15px"}}>
                <Offcanvas.Header className="preview-canvas">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="wifi" className="fa-rotate-180" />
                    </div>
                    <div className="preview-title">
                        <Offcanvas.Title>
                            <div className="preview-title">
                                <label>{tC("preview.title.sensor")}</label>
                                <div>{formData.name}</div>
                            </div>
                        </Offcanvas.Title>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-0" style={{fontSize: "13px"}}>
                    <form
                        ref={formRef}
                        className="container-fluid"
                        onSubmit={(e) => e.preventDefault()}>
                        <input type="hidden" name="id" defaultValue={formData.id} />
                        <div className="row">
                            <div className="col-md-8 col-12">
                                <label>{t("common.name")}</label>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    id="name"
                                    name="name"
                                    defaultValue={formData.name}
                                    required
                                />
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center">
                            <div className="col-md-3 col-12">
                                <label>{tC("field.model")}</label>
                                <Form.Select
                                    className="mb-2"
                                    id="model"
                                    name="model"
                                    value={model}
                                    style={{width: "120px"}}
                                    onChange={onChange}>
                                    <option value="">{tC("field.select")}</option>
                                    {models.map((model, index) => (
                                        <option key={index} value={model}>
                                            {model}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            <ManagerSensorsForm
                                item={formData}
                                setItem={setFormData}
                                model={model}
                            />
                        </div>
                    </form>

                    <div className="p-3 buttons-footer">
                        <div className="position-fixed bottom-0 end-0 mb-3 me-5">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}>
                                {tC("button.cancel")}
                            </button>
                            <FormButton
                                className="btn btn-primary ms-4"
                                onClick={handleSubmit}
                                isProcessing={isLoading}>
                                {tC("button.save")}
                            </FormButton>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default FormSensors;
